import React from "react"
import Partners from "./partners"
export default function Trusts2() {
  return (
    <section className="partners">
        <Partners />
    </section>
  )
}
